import { userRoleTypes } from "../constants"
import { getConfig } from "@cirrus/config"
import { markingRolesEnum as markingRoles } from "@cirrus/routing/author"
import { routeTemplates } from "@cirrus/routing/author"
import { routeTemplates as deliveryRouteTemplates } from "@cirrus-delivery/v1/router"

function getMarkingRole(role) {
  switch (role) {
    case "MARKER":
      return markingRoles.assessing

    case "MODERATOR":
      return markingRoles.moderation

    default:
      return null
  }
}

function getRedirectToLink(result) {
  switch (result.redirect_to_type) {
    case "marking_assess":
      return Url.author(
        `author/app#${routeTemplates.markingItem.build({
          scheduleId: result.schedule_id,
          markingRole: getMarkingRole(result.assessor_role),
          tab: "submissions",
        })}`,
      )

    case "exam_attempt":
      return Url.get(
        `/app#${deliveryRouteTemplates.keycodeStart.build(
          result.schedule_id,
        )}?loggedInByKeycode=true`,
        "/delivery",
      )

    case "review_session":
      return Url.get(
        `/app#${deliveryRouteTemplates.results.build(
          result.schedule_id,
          result.attempt_id,
          "reviewSession",
          "?loggedInByKeycode=true",
        )}`,
        "/delivery",
      )

    default:
      return Url.author("author/app")
  }
}

//TODO: Need to refactore delivery external login to handle the same way
export function redirectToAfterExternalLogin(result) {
  const { access_token } = result
  const authorConfig = getConfig("author")

  sessionStorage.setItem(authorConfig.TokenKey, access_token)
  window.location.href = getRedirectToLink(result)
}

export default function redirectToApp(result, stayLoggedIn = false) {
  const { access_token, exam_url, user_role } = result
  const authorConfig = getConfig("author")
  const deliveryConfig = getConfig("delivery")

  switch (user_role) {
    case userRoleTypes.author: {
      sessionStorage.setItem(authorConfig.TokenKey, access_token)
      window.location.href = "/author/app"
      return
    }

    case userRoleTypes.delivery: {
      sessionStorage.setItem(deliveryConfig.TokenKey, access_token)

      if (result.redirect_to_type) {
        window.location.href = getRedirectToLink(result)
      } else {
        window.location.href = "/delivery/app"
      }

      return
    }

    case userRoleTypes.all: {
      sessionStorage.setItem(authorConfig.TokenKey, access_token)
      sessionStorage.setItem(deliveryConfig.TokenKey, access_token)
      const parameter = stayLoggedIn ? "?stayLoggedIn=true" : ""

      window.location.href = `/${parameter}#role`
      return
    }
  }
}
